/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Preset_Not_FoundInputs */

const en_audio_description_export_preset_not_found = /** @type {(inputs: Audio_Description_Export_Preset_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preset not found`)
};

const fr_audio_description_export_preset_not_found = /** @type {(inputs: Audio_Description_Export_Preset_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préréglage introuvable`)
};

const de_audio_description_export_preset_not_found = /** @type {(inputs: Audio_Description_Export_Preset_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreinstellung nicht gefunden`)
};

const it_audio_description_export_preset_not_found = /** @type {(inputs: Audio_Description_Export_Preset_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preimpostazione non trovata`)
};

const ru_audio_description_export_preset_not_found = /** @type {(inputs: Audio_Description_Export_Preset_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительно заданные параметры не найдены`)
};

const es_audio_description_export_preset_not_found = /** @type {(inputs: Audio_Description_Export_Preset_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preajuste no encontrado`)
};

const zh_cn2_audio_description_export_preset_not_found = /** @type {(inputs: Audio_Description_Export_Preset_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到预设`)
};

const ja_audio_description_export_preset_not_found = /** @type {(inputs: Audio_Description_Export_Preset_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットが見つかりません`)
};

const hi_audio_description_export_preset_not_found = /** @type {(inputs: Audio_Description_Export_Preset_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट नहीं मिला`)
};

const pt_pt2_audio_description_export_preset_not_found = /** @type {(inputs: Audio_Description_Export_Preset_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predefinição não encontrada`)
};

/**
* | output |
* | --- |
* | "Preset not found" |
*
* @param {Audio_Description_Export_Preset_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_preset_not_found = /** @type {((inputs?: Audio_Description_Export_Preset_Not_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Preset_Not_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_preset_not_found(inputs)
	if (locale === "de") return de_audio_description_export_preset_not_found(inputs)
	if (locale === "it") return it_audio_description_export_preset_not_found(inputs)
	if (locale === "ru") return ru_audio_description_export_preset_not_found(inputs)
	if (locale === "es") return es_audio_description_export_preset_not_found(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_preset_not_found(inputs)
	if (locale === "ja") return ja_audio_description_export_preset_not_found(inputs)
	if (locale === "hi") return hi_audio_description_export_preset_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_preset_not_found(inputs)
	return en_audio_description_export_preset_not_found(inputs)
});